import React from 'react';
import ServicePage from '../components/services/ServicePage';
import projectingSigns from '../data/services/projecting-signs';

const ProjectingSigns: React.FC = () => <ServicePage data={projectingSigns} />;

export default ProjectingSigns;
